import type { InputTextDesignTokens } from '@primeuix/themes/types/inputtext';
import { SM_SIZE_TOKENS } from './sm-size.tokens';

export const INPUT_TEXT_STYLES: InputTextDesignTokens = {
  root: {
    sm: SM_SIZE_TOKENS,
  },
  css: () => `
    /* Keeps line-height proportional to the 13px font-size */
    .p-inputtext.p-inputtext-sm {
        line-height: 0.9375rem; /* 15px */
    }`,
};
